import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Container,
  FooterWrapper,
  Content,
  FooterBottom,
  PoweredByOrdering,
  LocationContainer,
  LocationRegion
} from './styles'
import { useApi, useConfig, useLanguage } from '~components'

export const Footer = ({ isFooterPage, isHome }) => {
  const [footerState, setfooterState] = useState({ body: null, loading: false, error: null })
  const [ordering] = useApi()
  const [{ configs }] = useConfig()
  const [, t] = useLanguage()
  const history = useHistory()

  const enabledPoweredByOrdering = configs?.powered_by_ordering_module?.value

  const getPage = async () => {
    setfooterState({ ...footerState, loading: true })
    try {
      const { content: { error, result } } = await ordering.pages('footer').get()
      if (!error) {
        setfooterState({ body: result.body, loading: false, error: null })
      } else {
        setfooterState({ body: null, loading: false, error: result })
      }
    } catch (err) {
      if (err.constructor.name !== 'Cancel') {
        setfooterState({ body: null, loading: false, error: [err.message] })
      }
    }
  }

  useEffect(() => {
    getPage()
  }, [])

  const goToPage = (page) => {
    history.push(page)
    window.scrollTo(0, 0)
  }

  if (isFooterPage) return null

  return (
    <Container $isHome={isHome}>
      <FooterWrapper>
        <Content className='locations'>
          <h4>{t('LOCATIONS', 'LOCATIONS')}</h4>
          <LocationContainer>
            <LocationRegion>
              <h5>{t('ONTARIO', 'Ontario')}</h5>
              <div className='city-list'>
                <a>{t('BRAMPTON', 'Brampton')}</a>
                <a>{t('BURLINGTON', 'Burlington')}</a>
                <a>{t('CAMBRIDGE', 'Cambridge')}</a>
                <a>{t('HAMILTON', 'Hamilton')}</a>
                <a>{t('KITCHENER', 'Kitchener')}</a>
                <a>{t('LONDON', 'London')}</a>
                <a>{t('MISSISSAUGA', 'Mississauga')}</a>
                <a>{t('NIAGARA_FALLS', 'Niagara Falls')}</a>
                <a>{t('OAKVILLE', 'Oakville')}</a>
                <a>{t('OTTAWA', 'Ottawa')}</a>
                <a>{t('ST_CATHERINES', "St. Catherine's")}</a>
                <a>{t('TORONTO', 'Toronto')}</a>
                <a>{t('WATERLOO', 'Waterloo')}</a>
              </div>
            </LocationRegion>
            <LocationRegion>
              <h5>{t('QUEBEC', 'Quebec')}</h5>
              <div className='city-list'>
                <a>{t('MONTREAL', 'Montreal')}</a>
              </div>
            </LocationRegion>
            <LocationRegion>
              <h5>{t('ALBERTA', 'Alberta')}</h5>
              <div className='city-list'>
                <a>{t('EDMONTON', 'Edmonton')}</a>
                <a>{t('SHERWOOD_PARK', 'Sherwood Park')}</a>
                <a>{t('ST_ALBERT', 'St. Albert')}</a>
              </div>
            </LocationRegion>
            <LocationRegion style={{ marginBottom: -10 }}>
              <h5>{t('BRITISH_COLUMBIA', 'British Columbia')}</h5>
              <div className='city-list'>
                <a>{t('ABBOTSFORD', 'Abbotsford')}</a>
                <a>{t('BURNABY', 'Burnaby')}</a>
                <a>{t('COQUITLAM', 'Coquitlam')}</a>
                <a>{t('RICHMOND', 'Richmond')}</a>
                <a>{t('SURREY', 'Surrey')}</a>
                <a>{t('VANCOUVER', 'Vancouver')}</a>
              </div>
            </LocationRegion>
          </LocationContainer>
        </Content>

        <Content>
          <h4>{t('LEGAL', 'Legal')}</h4>
          <div><a href='#' onClick={(e) => { e.preventDefault(); goToPage('/pages/privacy-policy-new') }}>{t('PRIVACY_POLICY', 'Privacy Policy')}</a></div>
          <div><a href='#' onClick={(e) => { e.preventDefault(); goToPage('/pages/terms-and-conditions-new') }}>{t('TERMS_AND_CONDITIONS', 'Terms & Conditions')}</a></div>
          <div><a href='#' onClick={(e) => { e.preventDefault(); goToPage('/pages/account-deletion-policy-new') }}>{t('ACCOUNT_DELETION_POLICY', 'Account Deletion')}</a></div>
          <div><a href='#' onClick={(e) => { e.preventDefault(); goToPage('/pages/refund-policy-new') }}>{t('REFUND_POLICY', 'Refund Policy')}</a></div>
        </Content>

        <Content>
          <h4>{t('PARTNERSHIP', 'Partnership')}</h4>
          <div><a href='#' onClick={(e) => { e.preventDefault(); goToPage('/pages/become-a-runner') }}>{t('BECOME_A_RUNNER', 'Become a Runner')}</a></div>
          <div><a href='#' onClick={(e) => { e.preventDefault(); goToPage('/pages/contact-us-new') }}>{t('CONTACT_US', 'Contact Us')}</a></div>
          <div><a href='#' onClick={(e) => { e.preventDefault(); goToPage('/pages/dial-a-bottle-new') }}>{t('DIAL_A_BOTTLE', 'Dial A Bottle')}</a></div>
        </Content>
      </FooterWrapper>

      {footerState.body && (
        <div
          style={{ wordBreak: 'break-word', padding: '20px 0', borderTop: '1px solid #333', marginTop: '20px' }}
          dangerouslySetInnerHTML={{ __html: footerState.body }}
        />
      )}
      <FooterBottom>
        {enabledPoweredByOrdering && (
          <PoweredByOrdering>
            {t('POWERED_BY', 'Powered by')}
            <a href='https://www.orderingplus.com' target='_blank' rel='noreferrer'>
              {' '}{t('ORDERING_PLUS', 'Orderingplus')}
            </a>
          </PoweredByOrdering>
        )}
      </FooterBottom>
    </Container>
  )
}

export default Footer
